import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { NavLink } from 'react-router-dom';
import routePaths from "app/components/Router/routePaths";
import brandLogoLight from 'images/upgrad/phoenix-logo-forDark.svg';
import brandLogoDark from "images/upgrad/phoenix-logo.svg";
import brandLogoMini from 'images/upgrad/phoenix-logo-icon.svg';
import styles from './index.scss';

const PrimaryLogo = function ({ className, variant="light", collapsed=false }) {

	return (
		<NavLink to={routePaths.homePage} className={cx(styles.root, className)}>
			{variant == "light" ? (
				<img
					className={styles.logo}
					src={collapsed ? brandLogoMini : brandLogoLight}
					alt="Phoenix - Home"
				/>
			) : (
				<img
					className={styles.logo}
					src={collapsed ? brandLogoMini : brandLogoDark}
					alt="Phoenix - Home"
				/>
			)}
		</NavLink>
	);
};

PrimaryLogo.propTypes = {
	className: PropTypes.string,
	collapsed: PropTypes.bool,
	variant: PropTypes.string
};

export default PrimaryLogo;
